import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import "../App.css"
import logo from "../assets/logo.png"
import { changeLanguage } from "../modules/modules"
import i18n from "../i18n"
import { useAuth } from '../context/AuthContext'


export const NavBar = (props) => {
    const { currentUser } = useAuth();
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    return (
        <nav className="header">
            <div className="logo">
                <img src={logo} alt="logo" />
            </div>

            <div className={`menu-icon ${isMenuOpen ? 'menu-open' : ''}`} onClick={toggleMenu} style={{ zIndex: 2001, color: isMenuOpen ? '#ff9800' : 'inherit' }}>
                {isMenuOpen ? (
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="32" height="32">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                ) : (
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="32" height="32" style={{ color: "#ff9800" }}>
                        <line x1="3" y1="12" x2="21" y2="12"></line>
                        <line x1="3" y1="6" x2="21" y2="6"></line>
                        <line x1="3" y1="18" x2="21" y2="18"></line>
                    </svg>
                )}
            </div>

            {/* Drawer Backdrop */}
            <div 
                className={`nav-backdrop ${isMenuOpen ? 'nav-backdrop-open' : ''}`} 
                onClick={closeMenu}
            ></div>

            <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
                <ul className="nav-links">
                    <li><a href="/" style={{ "color": props.is_welcome_page }} onClick={closeMenu}>{i18n.t("brand_name")}</a></li>
                    <li><Link to="/products" style={{ color: props.is_product_page }} onClick={closeMenu}>{i18n.t("products")}</Link></li>
                    <li><a href="/promotions" style={{ color: props.is_promotion_page }} onClick={closeMenu}>{i18n.t("promotions")}</a></li>
                    <li><Link to="/contact" style={{ color: props.is_contact_page }} onClick={closeMenu}>{i18n.t("contactUs")}</Link></li>
                    {
                        currentUser ? (
                            <li><a href="/admin/dashboard" target='_blank' rel='noopener noreferrer' onClick={closeMenu}>{i18n.t("dashboard")}</a></li>
                        ) : (
                            <li><a href="/login" onClick={closeMenu}>{i18n.t("login")}</a></li>
                        )
                    }
                </ul>
            </nav>
            <div className={`social-media ${isMenuOpen ? 'social-media-open' : ''}`}>
                {
                    i18n.language === "sw" ? (
                        <a href="#" className="icon-btn" aria-label="WhatsApp" style={{ textDecoration: "none" }} onClick={() => { changeLanguage("en"); closeMenu(); }}>
                            english
                        </a>
                    ) : (
                        <a href="#" className="icon-btn" aria-label="WhatsApp" style={{ textDecoration: "none" }} onClick={() => { changeLanguage("sw"); closeMenu(); }}>
                            swahili
                        </a>
                    )
                }
                <a href="https://wa.me/255658841717" target="_blank" rel="noopener noreferrer" className="icon-btn" aria-label="WhatsApp">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22" style={{ color: "blue" }}>
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                    </svg>
                </a>
                <a href="https://www.instagram.com/daty_abaya?igsh=NTJ2ZHc3dWphanc0" target="_blank" rel="noopener noreferrer" className="icon-btn" aria-label="Instagram">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22" style={{ color: "red" }}>
                        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
                    </svg>
                </a>
                <a href="https://www.tiktok.com/@daty_abaya_tz?_r=1&_t=ZS-95LfZsebKzd" target="_blank" rel="noopener noreferrer" className="icon-btn" aria-label="TikTok">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
                        <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z" />
                    </svg>
                </a>
            </div>
        </nav>
    )
}